'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useLayoutEffect, useRef, useState } from 'react';
import { mapCtx } from './MapContext';
import { useInvariantCallbackRef } from '../../../hooks';
export const MapMarkerInfo = ({ markerInfoOptions, children, marker, visible, onOpen, onClose }) => {
    const map = useContext(mapCtx);
    const [markerInfo, setMarkerInfo] = useState(null);
    const ref = useRef(null);
    const onOpenRef = useInvariantCallbackRef(onOpen);
    const onCloseRef = useInvariantCallbackRef(onClose);
    const initialOptions = useRef(markerInfoOptions);
    useLayoutEffect(() => {
        const node = ref.current;
        if (!node)
            return;
        const newMarkerInfo = new google.maps.InfoWindow({
            ...initialOptions.current,
            content: node
        });
        setMarkerInfo(newMarkerInfo);
        const handleClose = () => onCloseRef.current();
        const closeListener = newMarkerInfo.addListener('closeclick', handleClose);
        return () => closeListener.remove();
    }, [onCloseRef]);
    // Handle visibility and listeners
    const hasBeenOpenedRef = useRef(false);
    useLayoutEffect(() => {
        if (!map || !marker || !markerInfo)
            return;
        if (visible) {
            ref.current?.removeAttribute('hidden');
            markerInfo.open(map, marker);
            onOpenRef.current();
            hasBeenOpenedRef.current = true;
        }
        else if (hasBeenOpenedRef.current) {
            ref.current?.setAttribute('hidden', 'true');
            markerInfo.close();
            onCloseRef.current();
        }
    }, [map, marker, markerInfo, onCloseRef, onOpenRef, visible]);
    /**
     * Set hidden until InfoWindow is created AND LOADED to prevent show content in the document
     */
    return (_jsx("div", { ref: ref, hidden: true, "data-testid": "map-info-window", children: _jsx("div", { "data-testid": "map-marker-icon", children: children }) }));
};
